import { getTxtContent, getCsvContent, getPdfContent } from './BlogIdea.getContent';
import Icon from './BlogIdea.icon';

export default {
  getTxtContent,
  getCsvContent,
  getPdfContent,
  Icon,
  onMoreLikeThis: async (props, document) => {
    if (!props.canManageDocuments) {
      return null;
    }

    return props.generate({ likeId: document._id });
  },
};
